import useMediaQuery from '@mui/material/useMediaQuery';
import TopPicksCarousel from 'blocks/TopPicksCarousel/TopPicksCarousel';
import Button, { OUTLINED_BUTTON_TYPE_DARK } from 'components/Button/Button';
import { ArrowLeft, ArrowRight } from 'components/icons';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { breakpoints } from 'data/constants';
import { our_hot_picks } from 'data/translationKeys';
import { FC, TouchEvent, useCallback, useEffect, useState } from 'react';
import { HotelTopPicksType } from 'types/types';

interface ITopPicks {
  ourHotels: HotelTopPicksType[];
}

interface ISelectors {
  current: number;
  max: number;
}

const TopPicks: FC<ITopPicks> = ({ ourHotels }) => {
  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm})`);
  const moveMargin = 5; // number of pixels to move to change the current hotel
  const our_hot_picks_text = useLocalised(our_hot_picks);
  const [current, setCurrent] = useState(0);
  const [disable, setDisable] = useState(false);
  const [touchStart, setTouchStart] = useState(null as number | null);

  useEffect(() => {
    setCurrent(current % ourHotels.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCurrentChange = useCallback(
    (newCurrent: number) => {
      setDisable(true);
      if (newCurrent < 0) {
        newCurrent = ourHotels.length - 1;
      } else if (newCurrent >= ourHotels.length) {
        newCurrent = 0;
      }
      setCurrent(newCurrent);
      setTimeout(
        () => {
          setDisable(false);
        },
        isMobile ? 50 : 500
      );
    },
    [ourHotels.length, isMobile]
  );

  const handelTouchStart = (e: TouchEvent) => {
    setTouchStart(e.touches[0].clientX as number);
  };

  const handelTouchMove = (e: TouchEvent) => {
    if (!touchStart) {
      return;
    }
    const diff = touchStart - e.touches[0].clientX;
    if (diff > moveMargin) {
      handleCurrentChange(current + 1);
    } else if (diff < -moveMargin) {
      handleCurrentChange(current - 1);
    }
    setTouchStart(null);
  };

  const Selectors: FC<ISelectors> = ({ current, max }) => {
    return (
      <div className="top-picks-container__current">
        <Button
          title={<ArrowLeft />}
          onClick={() => (!disable ? handleCurrentChange(current - 1) : null)}
          buttonType={OUTLINED_BUTTON_TYPE_DARK}
          className="top-picks-container__button"
        />
        {current + 1}/{max}
        <Button
          title={<ArrowRight />}
          onClick={() => (!disable ? handleCurrentChange(current + 1) : null)}
          buttonType={OUTLINED_BUTTON_TYPE_DARK}
          className="top-picks-container__button"
        />
      </div>
    );
  };

  return (
    <div className="top-picks-container">
      <div className="top-picks-container__menu">
        <h1 className="top-picks-container__title">{our_hot_picks_text}</h1>
      </div>
      <TopPicksCarousel ourHotels={ourHotels} />
    </div>
  );
};

export default TopPicks;
